<template>

    <div class="card shadow-sm">
        <div class="card-header">
            <h5 class="m-0">
                {{ __('Bestellung am :date um :time', {date: $options.filters.localizeDate(groupedOrder.order_date), time: $options.filters.localizeTime(groupedOrder.order_date)}) }}
            </h5>
            <div>
                {{ __('Marktplatz-Bestellnr.: :number', {number: groupedOrder.internal_order_number}) }}
            </div>
        </div>
        <div class="card-body">

            <div v-for="order in groupedOrder.orders" class="mb-3 pb-3 border-bottom">

                <div class="pb-3 border-bottom">
                    <h6>
                        {{ order.supplier.name }}
                    </h6>
                    <div class="d-flex gap-3 mb-3 pb-3 border-bottom">
                        <span v-if="order.supplier.phone">
                            {{ __('Tel:') }}
                            <a :href="'tel:' + order.supplier.phone">
                                {{ order.supplier.phone }}
                            </a>
                        </span>
                        <span v-if="order.supplier.contact_email">
                            {{ __('E-Mail:') }}
                            <a :href="'mailto:' + order.supplier.contact_email">
                                {{ order.supplier.contact_email }}
                            </a>
                        </span>
                    </div>
                    <div>
                        {{ __('Bearbeitungsstatus: :status', {status: order.translated_order_status}) }}
                    </div>
                    <div v-if="order.delivery_option_data">
                        {{ __('Versandart: :name', {name: order.delivery_option_data.name}) }}
                    </div>
                    <div v-if="order.payment_method_data">
                        {{ __('Zahlungsart: :name', {name: order.payment_method_data.name}) }}
                    </div>
                    <div>
                        {{ __('Versandstatus: :status', {status: order.shipped ? __('Versandt') : __('Noch nicht versandt')}) }}
                        <span v-if="order.tracking_code">
                            - {{ order.tracking_code }}
                        </span>
                        <span v-if="order.tracking_url">
                            - <a :href="order.tracking_url" target="_blank">{{ __('Sendungsverfolgung') }}</a>
                        </span>
                    </div>
                    <div>
                        {{ __('Lieferanten-Bestellnr. :number', {number: order.supplier_order_number}) }}
                    </div>

                    <div class="text-success" v-if="order.delivery_option">
                        {{ __('Lieferzeit überlicherweise :days Tage', {days: order.delivery_option.delivery_time}) }}
                    </div>
                    <div class="d-flex gap-3">
                        <span class="">
                            {{ __('Summe netto: :amount', {amount: $options.filters.localizeAmount(order.subtotal)}) }}
                        </span>
                        <span>
                            {{ __('Versandkosten: :amount', {amount: $options.filters.localizeAmount(order.delivery)}) }}
                        </span>
                        <span>
                            {{ __('MwSt.: :amount', {amount: $options.filters.localizeAmount(order.tax)}) }}
                        </span>
                    </div>
                    <div class="fw-bold">
                        {{ __('Gesamtsumme inkl. MwSt.: :amount', {amount: $options.filters.localizeAmount(order.total)}) }}
                    </div>
                </div>


                <div v-for="orderItem in order.order_items" class="py-3 mb-3 border-bottom">
                    <div class="row align-items-center">
                        <div class="col-1">
                            <inertia-link :href="orderItem.product.permalink" v-if="orderItem.product">
                                <img class="img-fluid thumbnail" :src="orderItem.product.main_image_url" alt="" loading="lazy" />
                            </inertia-link>
                        </div>
                        <div class="col-11">
                            <h5>
                                <template v-if="orderItem.product">
                                    <inertia-link :href="orderItem.product.permalink" class="link-dark" v-if="orderItem.product">
                                        {{ orderItem.product_name }}
                                    </inertia-link>
                                </template>
                                <template v-else>
                                    {{ orderItem.product_name }}
                                </template>
                            </h5>
                            <div class="small">
                                {{ __('Lieferanten-Artikelnr.: :number', {number: orderItem.supplier_pid}) }}
                            </div>
                            <div class="mt-1 d-flex justify-content-between align-items-center">
                                <div>
                                    <span>
                                        {{ __('Einzelpreis: :price', {price: $options.filters.localizeAmount(orderItem.price)}) }}
                                    </span>
                                    <span class="text-secondary text-nowrap" v-if="orderItem.price_quantity > 1">
                                        {{ __('je :quantity Stck.', {quantity: orderItem.price_quantity}) }}
                                    </span>
                                    &middot;
                                    <span>
                                        {{ __('Anzahl: :quantity', {quantity: orderItem.quantity}) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="order.notes" class="bg-light p-3 mb-3">
                    <div class="small text-secondary mb-1">
                        {{ __('Ihre Bemerkung') }}
                    </div>
                    <div>
                        {{ order.notes }}
                    </div>
                </div>

                <!--                   @todo     <inertia-link :href="route('orders.show', order)" class="btn btn-outline-primary">
                                            {{ __('Bestelldetails') }}
                                        </inertia-link>-->
                <inertia-link :href="route('orders.again', order)" method="post" as="button" class="btn btn-outline-primary">
                    {{ __('Erneut bestellen') }}
                </inertia-link>
<!--                <inertia-link :href="route('orders.refunds.index', order)" class="btn btn-outline-dark">
                    {{ __('Retoure / Reklamation') }}
                </inertia-link>-->
                <!--@todo only if fulfilled?-->
                <!--                            <inertia-link :href="route('orders.archive-order', order)" method="post" as="button" class="btn btn-outline-secondary">
                                                <template v-if="order.archived_at">
                                                    {{ __('Archivieren rückgängig machen.') }}     
                                                </template>
                                                <template v-else>
                                                    {{ __('Archivieren') }}     
                                                </template>
                                            </inertia-link>-->
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        props: [
            'groupedOrder',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        computed: {
        },
    }
</script>
